import { createPortal } from 'react-dom';
import { ICommentsAndObservations } from '../../../../types/global';
import BordCommentsAndObservations from '../../../../components/BordComentsAndObservations/BordComentsAndObservations';
import { IResponsibleUserData } from '../../../../types/responsibleUser.types';
import useLockScroll from '../../../../hooks/useLockScroll';
import './CheckOrAddCommentsModal.scss';

const CheckOrAddCommentsModal = ({
  closeModal,
  orderComments,
  handleSubmitComments,
  loading,
  isLoadingInitialComments,
  responsibleUsers = [],
  organizationId,
}: {
  closeModal: () => void;
  orderComments?: ICommentsAndObservations[];
  handleSubmitComments?: (comment: ICommentsAndObservations) => Promise<void>;
  loading: boolean;
  isLoadingInitialComments?: boolean;
  responsibleUsers?: IResponsibleUserData[];
  organizationId?: number;
}) => {
  useLockScroll(true);

  return (
    <>
      {createPortal(
        <div className="checkOrAddCommentsModal">
          <BordCommentsAndObservations
            comments={orderComments}
            closeModalCallback={closeModal}
            handleSubmitComments={handleSubmitComments}
            loading={loading}
            isLoadingInitialComments={isLoadingInitialComments}
            responsibleUsers={responsibleUsers}
            organizationId={organizationId}
          />
        </div>,
        document.body
      )}
    </>
  );
};

export default CheckOrAddCommentsModal;
